import {
  AiFillExclamationCircle,
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineLike,
  AiOutlineMinus,
  AiOutlinePlus,
  AiOutlineShoppingCart,
  AiOutlineUserAdd,
} from 'react-icons/ai';
import {
  BiCheckCircle,
  BiUser,
  BiUserCheck,
  BiX,
  BiXCircle,
} from 'react-icons/bi';
import {
  BsArrowCounterclockwise,
  BsChatHeart,
  BsFillPinAngleFill,
  BsInfoSquare,
  BsTrash,
} from 'react-icons/bs';
import { CiClock2 } from 'react-icons/ci';
import {
  FaAppStore,
  FaFacebook,
  FaFacebookF,
  FaFacebookMessenger,
  FaGlobe,
  FaInstagram,
  FaLinkedin,
  FaPinterestP,
  FaRegAddressCard,
  FaTiktok,
  FaYoutube,
} from 'react-icons/fa';
import { FaCartPlus, FaXTwitter } from 'react-icons/fa6';
import {
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiEye,
  FiEyeOff,
  FiHome,
  FiInfo,
  FiMenu,
} from 'react-icons/fi';
import { GiCheckMark } from 'react-icons/gi';
import { GoLink } from 'react-icons/go';
import { GrDocumentTime } from 'react-icons/gr';
import { HiOutlineMail } from 'react-icons/hi';
import { IoIosSearch } from 'react-icons/io';
import {
  IoAirplane,
  IoCardOutline,
  IoLogoReddit,
  IoMoonOutline,
  IoSparklesOutline,
  IoStar,
  IoStarHalf,
  IoStarOutline,
  IoSunnyOutline,
  IoTrophy,
  IoTrophyOutline,
} from 'react-icons/io5';
import { LiaBirthdayCakeSolid, LiaGooglePlay } from 'react-icons/lia';
import { LuCircleAlert, LuPenLine } from 'react-icons/lu';
import { MdOutlineRateReview } from 'react-icons/md';
import {
  RiCoinsLine,
  RiCustomerServiceLine,
  RiFileCopy2Line,
} from 'react-icons/ri';
import { SlPresent, SlSettings } from 'react-icons/sl';

export const Icons = {
  AddressCard: FaRegAddressCard,
  Alert: LuCircleAlert,
  Apple: FaAppStore,
  BankCard: IoCardOutline,
  Cart: AiOutlineShoppingCart,
  CartPlus: FaCartPlus,
  CheckCircle: BiCheckCircle,
  CheckMark: GiCheckMark,
  Clock: CiClock2,
  Close: BiX,
  Coins: RiCoinsLine,
  Chevron: {
    Down: FiChevronDown,
    Left: FiChevronLeft,
    Right: FiChevronRight,
    Up: FiChevronUp,
  },
  CS: {
    Chat: BsChatHeart,
    Phone: RiCustomerServiceLine,
  },
  Error: BiXCircle,
  Exclamation: AiFillExclamationCircle,
  Eye: FiEye,
  EyeOff: FiEyeOff,
  FileCopy: RiFileCopy2Line,
  Google: LiaGooglePlay,
  Heart: {
    Filled: AiFillHeart,
    Outline: AiOutlineHeart,
  },
  History: GrDocumentTime,
  Home: FiHome,
  Info: {
    Square: BsInfoSquare,
    Circle: FiInfo,
  },
  Link: GoLink,
  Menu: FiMenu,
  Minus: AiOutlineMinus,
  Moon: IoMoonOutline,
  Pin: BsFillPinAngleFill,
  Plane: IoAirplane,
  Plus: AiOutlinePlus,
  ReturnArrow: BsArrowCounterclockwise,
  Rewards: {
    Present: SlPresent,
    Birthday: LiaBirthdayCakeSolid,
    WriteReview: MdOutlineRateReview,
  },
  Search: IoIosSearch,
  Settings: SlSettings,
  Social: {
    Facebook: {
      Standard: FaFacebook,
      F: FaFacebookF,
      Messenger: FaFacebookMessenger,
      Like: AiOutlineLike,
    },
    Website: FaGlobe,
    Instagram: FaInstagram,
    LinkedIn: FaLinkedin,
    Tiktok: FaTiktok,
    Youtube: FaYoutube,
    XTwitter: FaXTwitter,
    Reddit: IoLogoReddit,
    Email: HiOutlineMail,
    Pinterest: FaPinterestP,
  },
  Sparkles: {
    Outline: IoSparklesOutline,
  },
  Star: {
    Full: IoStar,
    Half: IoStarHalf,
    Outline: IoStarOutline,
  },
  Sun: IoSunnyOutline,
  Trash: BsTrash,
  Trophy: {
    Outline: IoTrophyOutline,
    Fill: IoTrophy,
  },
  User: {
    NoAuth: BiUser,
    Auth: BiUserCheck,
    Add: AiOutlineUserAdd,
  },
  Writing: LuPenLine,
};
